import React, { ReactNode } from 'react';
import { CommonModal } from './common-modal';
import { Button, Modal } from 'react-bootstrap';

type ConfirmationModalProps = {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string | ReactNode;
  footerUi?: ReactNode;
  footerClassName?: string;
  showCloseButton?: boolean;
};

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = 'Confirmation',
  message = 'Are you sure you want to do this?',
  showCloseButton = false,
  footerClassName,
  footerUi,
  ...props
}: ConfirmationModalProps) => {
  return (
    <CommonModal showCloseButton={showCloseButton} show={show} onHide={onHide} centered title={title} {...props}>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer className={footerClassName}>
        {footerUi ? (
          footerUi
        ) : (
          <>
            <Button variant='primary' onClick={onConfirm}>
              Confirm
            </Button>
            <Button variant='secondary' onClick={onHide}>
              Cancel
            </Button>
          </>
        )}
      </Modal.Footer>
    </CommonModal>
  );
};

export default ConfirmationModal;
